import { styled } from '@mui/material';

import { Line } from '@mewa/ui';

const NoTabsSpacer = styled(Line)({
  marginTop: 0,
  marginBottom: 0,
});

export default NoTabsSpacer;
